import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { celebrations } from '../registries';
import type { Reward } from '../../../data/schemas';

export interface RewardScreenProps {
  reward: Reward;
  levelTitle: string;
  onContinue: () => void;
}

export const RewardScreen: React.FC<RewardScreenProps> = ({
  reward,
  levelTitle,
  onContinue,
}) => {
  const celebration = celebrations.get(reward.celebration);

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ') onContinue();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onContinue]);

  return (
    <div
      className="fixed inset-0 z-40 flex flex-col items-center justify-center bg-gradient-to-b from-[#8ecae6] via-[#A8D8EA] to-[#FFE66D] p-6"
      data-name={`reward-${reward.sticker}`}
    >
      <motion.div
        initial={{ scale: 0.4, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 220, damping: 14 }}
        className="text-8xl mb-4"
        aria-hidden
      >
        {celebration.emoji}
      </motion.div>
      <motion.p
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.15 }}
        className="text-3xl md:text-4xl font-display font-bold text-white drop-shadow mb-2 text-center"
      >
        {levelTitle}
      </motion.p>
      <motion.div
        initial={{ y: 24, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="mt-4 flex flex-col items-center gap-3"
      >
        <div
          className="w-28 h-28 rounded-full bg-white shadow-lg flex items-center justify-center text-5xl"
          data-name={`sticker-${reward.sticker}`}
        >
          ⭐
        </div>
        {reward.unlock ? (
          <p className="text-white/90 font-body text-lg" data-name={`unlock-${reward.unlock}`}>
            + ny ting
          </p>
        ) : null}
        <button
          type="button"
          onClick={onContinue}
          className="mt-4 min-h-[96px] min-w-[96px] px-10 rounded-2xl bg-white text-[#6441A5] font-display text-2xl font-bold shadow-md active:scale-95 transition-transform"
        >
          Videre
        </button>
      </motion.div>
    </div>
  );
};

export default RewardScreen;
